
{
  "title": "You have unsaved changes",
  "message": "If you leave this page you will lose your unsaved changes, are you sure you want to discard changes?",
  "actions": {
    "continue-editing": "Continue Editing",
    "discard-changes": "Discard unsaved changes"
  }
}
